import Head from 'next/head';
import styles from './Legal.module.css';

export default function TermsOfService() {
  return (
    <>
      <Head>
        <title>Terms of Service | ShuffleDB</title>
        <meta
          name="description"
          content="Terms of Service for ShuffleDB and PostDat Publisher."
        />
      </Head>
      <main className={styles.page}>
        <article className={styles.document}>
          <h1>Terms of Service</h1>
          <p className={styles.updated}>Effective August 7, 2026</p>

          <p>
            These Terms of Service (“Terms”) govern your access to shuffledb.com,
            PostDat Publisher, and related ShuffleDB services (collectively, the
            “Services”). By using the Services, you agree to these Terms.
          </p>

          <h2>Eligibility and accounts</h2>
          <p>
            You must be legally able to enter this agreement and meet the minimum age
            required in your location. You are responsible for your account, credentials,
            connected platform accounts, and all activity conducted through them.
          </p>

          <h2>The Services</h2>
          <p>
            PostDat helps users prepare, schedule, and publish content to supported
            third-party platforms. Features may be changed, suspended, limited, or
            discontinued. Publishing depends on third-party availability, permissions,
            review requirements, quotas, and technical rules, so delivery at a specific
            time is not guaranteed.
          </p>

          <h2>Your content and instructions</h2>
          <p>
            You retain ownership of content you submit. You grant us a limited license
            to host, process, reproduce, format, transmit, and publish that content only
            as needed to operate the Services and carry out your instructions. You
            represent that you have the rights and permissions needed to use and publish
            the content, including music, images, video, trademarks, and personal data.
          </p>

          <h2>Acceptable use</h2>
          <p>You may not use the Services to:</p>
          <ul>
            <li>Violate law, intellectual-property rights, privacy, or publicity rights.</li>
            <li>Publish deceptive, harmful, abusive, illegal, or unauthorized content.</li>
            <li>Spam, manipulate engagement, evade platform limits, or impersonate others.</li>
            <li>Probe, disrupt, reverse engineer, or gain unauthorized access to systems.</li>
            <li>Upload malware or interfere with the operation or security of the Services.</li>
          </ul>

          <h2>Third-party platforms</h2>
          <p>
            Connected services—including TikTok, Instagram, Facebook, Google, and
            YouTube—are operated by third parties. You must comply with their terms,
            policies, content rules, and permission requirements. We are not responsible
            for third-party services, their availability, or actions they take regarding
            your account or content.
          </p>

          <h2>Suspension and termination</h2>
          <p>
            You may stop using the Services and disconnect platforms at any time. We may
            restrict or terminate access when reasonably necessary to protect users or
            systems, respond to legal requirements, address violations, or prevent harm.
          </p>

          <h2>Disclaimers</h2>
          <p>
            The Services are provided “as is” and “as available.” To the extent permitted
            by law, we disclaim implied warranties, including merchantability, fitness for
            a particular purpose, and non-infringement. We do not warrant uninterrupted or
            error-free operation or successful publication by a third-party platform.
          </p>

          <h2>Limitation of liability</h2>
          <p>
            To the fullest extent permitted by law, ShuffleDB will not be liable for
            indirect, incidental, special, consequential, exemplary, or punitive damages,
            or for lost profits, data, goodwill, or business opportunities arising from
            your use of the Services.
          </p>

          <h2>Changes</h2>
          <p>
            We may revise these Terms as the Services evolve. Continued use after revised
            Terms become effective constitutes acceptance of those Terms.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about these Terms may be sent to{' '}
            <a href="mailto:support@shuffledb.com">support@shuffledb.com</a>.
          </p>
        </article>
      </main>
    </>
  );
}
